import React, { useEffect, useState } from 'react';
import styles from './MMVSelectModal.module.scss';
import { Brand, Model, Variant } from '@interfaces/mmv.types';
import { MMVService } from '@services/mmvselection';
import ModalManager from '../ModalManager';
import SearchTrigger from '../SearchTrigger';
import SearchInput from '../SearchInput';
import { useIsMobile } from '@hooks/use-mobile';
import assetLoader from '@utils/internalImageLoder';
import { fetchVariantDetailsPrice } from '@services/queries/findVariantDetailsPrice';
import ComparisonVariantDetails, { CarVariant } from '../ComparisonVariantDetails';
import SearchBar from '../SearchBar';
import ImageAtom from '@components/atoms/Image';

interface AddToCompareModalProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    cityName: string;
    handleAddToCompare: (brand: string, model: string, variantSlug: string, selectedVariant?: CarVariant | null) => void;
}

const AddToCompareModal = ({ title, isOpen, onClose, cityName, handleAddToCompare }: AddToCompareModalProps) => {
    const [brands, setBrands] = useState<Brand[]>([]);
    const [models, setModels] = useState<Model[]>([]);
    const [variants, setVariants] = useState<CarVariant[]>([]);

    const [selectedBrand, setSelectedBrand] = useState<Brand | null>(null);
    const [selectedModel, setSelectedModel] = useState<Model | null>(null);
    const [selectedVariant, setSelectedVariant] = useState<CarVariant | null>(null);
    const [isEditingBrand, setIsEditingBrand] = useState<boolean>(false);
    const [isEditingModel, setIsEditingModel] = useState<boolean>(false);
    const [isEditingVariant, setIsEditingVariant] = useState<boolean>(false);

    const [searchTerm, setSearchTerm] = useState('');

    const isMobile = useIsMobile();

    useEffect(() => {
        if (selectedModel && variants.length > 0) {
            setIsEditingVariant(true);
        }
    }, [variants, selectedModel]);

    useEffect(() => {
        const fetchBrands = async () => {
            if (!isOpen) return;
            try {
                const brandDetails = await MMVService.getBrands();
                setBrands(brandDetails);
            } catch (error) {
                console.error('Failed to fetch brands', error);
            }
        };

        fetchBrands();
    }, [isOpen]);

    useEffect(() => {
        const fetchModels = async () => {
            if (!selectedBrand) return;

            try {
                const response = await MMVService.getModels(selectedBrand.make_id);
                setModels(response);
            } catch (error) {
                console.error('Failed to fetch models:', error);
            }
        };

        fetchModels();
    }, [selectedBrand]);


    useEffect(() => {
        const fetchVariants = async () => {
            if (!selectedBrand || !selectedModel) return;
            const slug = selectedModel?.slug || "";
            const variantsData = await fetchVariantDetailsPrice(slug, cityName)
            setVariants(variantsData)
        };

        fetchVariants();
    }, [selectedBrand, selectedModel]);


    return (
        <ModalManager isOpen={isOpen} onClose={onClose} title={title} customClass={styles.modalCustomClass} showClose={isMobile} modalBodyClass={styles.modalBody}>
            {!selectedBrand || isEditingBrand ? <div className={styles.dropdownCard}>
                {/* <div className={styles.brandLabel}> <span className={styles.label} onClick={() => setIsEditingBrand(false)}>Brand?</span></div> */}
                <div className={styles.brandList}>
                    <SearchBar value={searchTerm} onChange={setSearchTerm} searchIcon={`${assetLoader()}/icons/search_dark.svg`} />
                    {brands
                        .filter((brand) =>
                            brand.make.toLowerCase().includes(searchTerm.toLowerCase())
                        )
                        .map((brand) => (
                            <div
                                key={brand.make_id}
                                className={styles.brandItem}
                                onClick={() => {
                                    setSelectedBrand(brand);
                                    setSelectedModel(null);
                                    setSelectedVariant(null);
                                    setIsEditingBrand(false);
                                    setIsEditingModel(true);
                                }}
                            >
                                <ImageAtom className={styles.brandImg} src={`${assetLoader()}/icons/car-brands-dark/${brand.make}.svg`} alt={brand.make.toLowerCase()} height={24} width={24}/>
                                <span>{brand.make}</span>
                            </div>
                        ))}
                </div>
            </div> : <div className={styles.brandSelected} onClick={() => { setIsEditingBrand(true); setIsEditingModel(false) }} >
                <span>Brand</span>  <span className={styles.staticLabel}>{selectedBrand?.make} </span></div>
            }

            {selectedBrand && isEditingModel ? (
                <div className={styles.dropdownCard}>
                    <div className={styles.brandLabel} onClick={() => setIsEditingModel(false)}> <span className={styles.label}>Model?</span></div>
                    <div className={styles.brandList}>
                        {models.map((model) => (
                            <div
                                key={model.model_id}
                                className={styles.brandItem}
                                onClick={() => {
                                    setSelectedModel(null);
                                    setSelectedVariant(null);
                                    setTimeout(() => {
                                        setSelectedModel(model);
                                        setIsEditingModel(false);
                                    }, 0);
                                }}
                            >
                                <span>{model.model}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div
                    className={styles.brandSelected}
                    onClick={() => { setIsEditingModel(true); setIsEditingVariant(false); }}
                >
                    <span className={styles.staticLabel} >Model</span>
                    <div> {selectedModel ? <span className={styles.staticLabel}>{selectedModel?.model}</span> : <div
                        className={styles.selectBtn}>Select</div>}</div>
                </div>
            )}

            {/* {selectedModel && variants?.length > 0 && isEditingVariant && !selectedVariant ? (
                <div className={styles.dropdownCard}>
                    <div className={styles.brandLabel} onClick={() => setIsEditingVariant(false)}> <span className={styles.label}>Variant?</span></div>
                    <div className={styles.variantList}>
                        {variants.map((variant) => (
                            <div
                                key={variant.slug}
                                style={{ width: "100%" }}
                                onClick={() => {
                                    setSelectedVariant(variant)
                                    setIsEditingVariant(false)
                                }}
                            >
                                <ComparisonVariantDetails variant={variant} />
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div
                    className={styles.brandSelected}
                    onClick={() => setIsEditingVariant(true)}
                >
                    <span className={styles.staticLabel} >Variant</span>
                    <div> {selectedVariant ? <span className={styles.staticLabel}>{selectedVariant?.variantName}</span> : 
                    <div
                        className={styles.selectBtn}>Select</div>}</div>
                </div>
            )} */}

            {!isEditingVariant ? (
                <div
                    className={styles.brandSelected}
                    onClick={() => {
                        if (variants.length > 0) {
                            setIsEditingVariant(true);
                        }
                    }}
                >
                    <span className={styles.staticLabel}>Variant</span>
                    {selectedVariant ? (
                        <span className={styles.staticLabel}>{selectedVariant.variantName}</span>
                    ) : (
                        <div className={styles.selectBtn}>Select</div>
                    )}
                </div>
            ) : (
                <div className={styles.dropdownCard}>
                    <div
                        className={styles.brandLabel}
                        onClick={() => setIsEditingVariant(false)}
                    >
                        <span className={styles.label}>Variant?</span>
                    </div>
                    <div className={styles.variantList}>
                        {variants.map((variant) => (
                            <div
                                key={variant.slug}
                                style={{ width: "100%" }}
                                onClick={() => setSelectedVariant(variant)}
                            >
                                <ComparisonVariantDetails variant={variant} isSelected={selectedVariant?.slug === variant.slug} />
                            </div>
                        ))}
                    </div>
                </div>
            )}


            <div className={styles.modalFooter}>
                {!isMobile && <button className={styles.cancelBtn} onClick={() => onClose()}>Cancel</button>}
                <button
                    onClick={() => handleAddToCompare(selectedBrand?.make ?? '', selectedModel?.slug ?? '', selectedVariant?.slug ?? '', selectedVariant)}
                    className={styles.addBtn}
                    disabled={!selectedBrand || !selectedModel || !selectedVariant}
                >
                    Add to compare
                </button>

            </div>

        </ModalManager>

    );
};

export default AddToCompareModal;
